export default remote => ({
    country: () => remote.get(`user/country`)
});
